module.exports = __webpack_public_path__ + "media/images/tactic-d1287e11e42038b0c9fca0a2c0b4b78b.svg";